function Suspend(config, renderer) {
  let calculator = new Calculator2021(CalculatorConfiguration, fundShares)
  $.extend(this, new Details(renderer))

  this.init = function () {
    const currentSalary = session.pension.currentSalary
    const averageSalary = CalculatorConfiguration.yearlyAverageSalary

    let estimatedPension = calculator.calculate(session.pension, session.pension.thirdPillar.averageMonthlyContribution)
    return {
      estimatedPension: estimatedPension,
      currentSalary: currentSalary || averageSalary,
      suspendDiff: (1 - estimatedPension.totalSuspend / estimatedPension.total) * 100.0,
      suspendLoss: Math.abs(estimatedPension.totalSuspendLoss),
      moreThan10YearsToRetirement: estimatedPension.yearsUntilRetirement >= 10
    }
  }

  function onConsentCheckboxChecked() {
    if ($('[name=consent]:checked').length === 5) $('#sign-suspend').removeAttr('disabled')
    else $('#sign-suspend').attr('disabled', 'disabled')
  }

  function signSuspend() {
    location.href = '#suspendsigning'
  }

  this.done = function (urlParams, args) {
    $('[name=consent]').on('change', onConsentCheckboxChecked)
    $('#sign-suspend').on('click', signSuspend)

    $('[data-toggle="popover"]').popover({
      animation: false
    })

    let estimatedPension = args.estimatedPension
    new SuspendPensionChart().chart('#suspend-pension-chart', estimatedPension, args.currentSalary)
  }
}